import React from 'react';
import {ReactCountryFlag} from 'react-country-flag';

interface RegisterMembersCardProps {
  image: string;
  text: string;
  name: string;
  firstCode: string;
  secondCode: string;
}

const RegisterMembersCard: React.FC<RegisterMembersCardProps> = ({
  image,
  text,
  name,
  firstCode,
  secondCode,
}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2.5 px-4 text-center">
      <div className="relative">
        <img
          loading="lazy"
          src={image}
          className="h-[250px] w-[250px] min-w-[250px] rounded-full object-cover"
          alt={name}
        />
        <ReactCountryFlag
          svg
          loading="lazy"
          alt={`${firstCode}`}
          countryCode={firstCode}
          className="!h-16 !w-16 absolute bottom-7 left-0 rounded-full object-cover"
        />
        <ReactCountryFlag
          svg
          loading="lazy"
          alt={`${secondCode}`}
          countryCode={secondCode}
          className="!h-16 !w-16 absolute top-7 right-0 rounded-full object-cover"
        />
      </div>
      <div className="mt-1.5 font-bold text-base">{text}</div>
      <div className="text-sm sm:text-lg">{name}</div>
    </div>
  );
};

export default RegisterMembersCard;
